import { getSelectedCategory } from "app/pages/industry-analysis/common/getSelectedCategory";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import DurationService from "app/services/DurationService";

interface IQueryParams {
    country: number;
    from: string;
    to: string;
    compareFrom: string;
    compareTo: string;
    isWindow: boolean;
    webSource: string;
    includeSubdomains: boolean;
}

export const getQueryParams = (): IQueryParams => {
    const params = proNavigator.getParams();
    const { country, webSource, duration, comparedDuration, includeSubdomains = true } = params;
    const { forAPI: durationsForApi } = DurationService.getDurationData(duration, comparedDuration);
    const { from, to, compareFrom, compareTo, isWindow } = durationsForApi;
    return { country, from, to, webSource, compareFrom, compareTo, isWindow, includeSubdomains };
};

interface IIndustryQueryParams extends IQueryParams {
    keys: string;
    categoryHash: string;
}

export const getIndustryQueryParams = (): IIndustryQueryParams => {
    const baseQueryParams = getQueryParams();
    const selectedCategory = getSelectedCategory();
    const { forApi: keys, categoryHash } = selectedCategory;
    const queryParams = { ...baseQueryParams, keys, categoryHash };
    return queryParams;
};
